import { useEffect, useLayoutEffect } from "react";
const useOutSideClick = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (evt) => {
            if (ref.current && !ref.current.contains(evt.target)) {
                callback(); //Do what you want to handle in the callback
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
};
export default useOutSideClick;
export const useReportZIndex = (drowerOpened, id, zIndex = "2", defaultIndex = "11") => {
    useLayoutEffect(() => {
        const reportNavbar = document.getElementById(id);
        if (reportNavbar) {
            reportNavbar.style.zIndex = drowerOpened ? zIndex : defaultIndex;
        }
    }, [drowerOpened]);
};
